import { ButtonStatus, Sounds } from "../../types/Enum";
import { ButtonBounds } from "../../types/Interface";
import BaseButton from "./BaseButton";

export default class BonusPlayButton extends BaseButton {
  constructor(bounds: ButtonBounds) {
    super("bonus_play", Sounds.click2);
    Object.assign(this, bounds);
    this.setVisible(false);
    this.EventBus.on(this.EnumEventBus.setBPlayButStatus, (value: ButtonStatus) => this.setButton(value));
  }
  handlePress(): void {
    this.setAvaible(false);
    this.EventBus.emit(this.EnumEventBus.spin, false);
  }
  setButton(value: ButtonStatus) {
    if (value == ButtonStatus.semiOpacity) {
      this.setAvaible(false);
    } else if (value == ButtonStatus.show) {

      this.setAvaible(true);
      this.setVisible(true);
    } else if (value == ButtonStatus.hide) {

      this.setAvaible(false);
      this.setVisible(false);
    }
  }
  setAvaible(value: boolean) {
    this.alpha = value ? 1 : .5;
    this.setInteractivity(value)
  }
  setInteractivity(v: boolean) {
    this.interactive = v;
  }
  setVisible(value: boolean) {
    this.visible = value;
    this.exchangeTexture(this.regular);
  }
}